import React, { Component } from 'react';

import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ContentClear from 'material-ui/svg-icons/content/clear';
import FlatButton from 'material-ui/FlatButton';

import TableClients from './TableClients';
import SendTask from './SendTask';
import clientsStore from '../../stores/clientsStore';
import ClientDialog from '../ClientDialog';

const styles={
    top: {
        marginTop: "16px",
        marginBottom: "16px"
    },
    customInput: {
        marginLeft: "15%", 
        marginRight: "15%", 
        marginTop: "32px", 
        marginBottom: "64px"
    }
}


class CustomInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "",
            lastQuery: ""
        }
    }
    
    _onChangeValue(e) {
        this.setState({value: e.target.value});
    }

    _getInput() {
        if(this.state.value.trim() === "") {
            this._clearInput();
        } else {
            this.props.onSearchInput(this.state.value);
            this.setState({ value: "", lastQuery: `Ultima consulta: [${this.state.value}]` });    
        }    
    }
    _clearInput() {
        this.props.onSearchInput("");
        this.setState({ value: "", lastQuery: "" }, () => {
            this.textInput.focus();
        });
    }

    componentDidMount() {
        this.textInput.focus();
    }
    

    render() {
        const clearButton = (this.state.lastQuery.trim() !== "" || this.state.value.trim() !== "") ? (
                                    <IconButton 
                                        style={{position: "absolute"}} 
                                        onTouchTap={() => {this._clearInput()}}
                                    >
                                        <ContentClear />
                                    </IconButton>
                            ) : (<span></span>);

        return (
            <form style={styles.customInput} onSubmit={(e) => {e.preventDefault(); this._getInput(); return false;}}>
                <TextField
                    hintText="Buscar"
                    type="input"
                    fullWidth={true}
                    value={this.state.value}
                    onChange={(e) => { this._onChangeValue(e) }}
                    ref={(input) => { this.textInput = input; }}

                    errorText={this.state.lastQuery}
                    errorStyle={{color: "#2196F3"}}
                />
                {clearButton}
            </form>
        );
    }
}

const Selectors = ({selectAll, clearSelection, createClient}) => (
    <div>
        <FlatButton label="Seleccionar todos" onTouchTap={selectAll} />
        <FlatButton label="Anular seleccion" onTouchTap={clearSelection} />
        <FlatButton label="Agregar clente" onTouchTap={createClient}  />
    </div>
);



class SearchCients extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            clients: []
        }
    }
    componentDidMount() {
        clientsStore.getClients({
            onSuccess: (response) => {
                this.setState( { clients: response } );
            }
        });
    }
    
    _search(response) {
        this.setState({
            clients: clientsStore.searchClientes({
                        query: response
                    })
        });
    } 

    _selectAll() {
        document.getElementById("listClients").querySelectorAll("label").forEach((item, index) => {
            if(!item.querySelector("input").checked) {
                item.click();
            }
        });
    }
    _clearSelection() {
        document.getElementById("listClients").querySelectorAll("label").forEach((item, index) => {
            if(item.querySelector("input").checked) {
                item.click();
            }
        });
    }
    _createClient(data, onSuccess, onError) {
        // Create client:
        // Llamar Dialog con campos respectivos
        // Validar entradas?? o recoger la respuesta del servidor
        // Si el respuesta.status es 1 entonces avisar de que se agrego correctmente al cliente
        // sino mandar mensaje de error
        console.log("Se está intentando crear un cliente.");

        clientsStore.createClient({
            newClient: {
                clientName  : data.clientName,
                description : data.description,
                labels      : data.labels
            },
            onSuccess: (clients) => {
                this._refreshClients(clients);
                if(onSuccess) onSuccess();
            },
            onError: () => {

            }
        });
    }
    _refreshClients(newClients) {
        this.setState({clients: newClients});
    }
    render() {
        return(
            <div style={styles.top}>
                <CustomInput onSearchInput={(response) => { this._search(response) } } />
                {/* En storedCommands se uso una clase donde se creaba dos botones,
                    uno de ellos abria el otro. Cambiar createClient despues por esta opcion? */}
                <Selectors
                    selectAll={ () => { this._selectAll() } } 
                    clearSelection={ () => { this._clearSelection() } }
                    createClient={ () => { this.refDialog._clearAndOpen() } } 
                />
                <ClientDialog 
                    addClient={(data, onSuccess, onError) => {
                        this._createClient(data, onSuccess, onError);
                    }}
                    ref={(refDialog) => this.refDialog = refDialog}
                />
                <TableClients clients={this.state.clients} />
                <SendTask clients={this.state.clients} />
            </div>
        );
    }
}

export default SearchCients;



// WEBPACK FOOTER //
// ./src/components/MainComponents/SearchClients.js